import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Dialog, DialogContent, DialogHeader, DialogOverlay, DialogPanel, DialogTitle } from '@zep/ui';
import { StoreCategoryString } from '../../../../consts';
import UploadTypeSelectionCard from './UploadTypeSelectionCard';
import S from './UploadTypeSelectionModal.module.scss';
const UploadTypeSelectionModalInner = () => {
  const {
    visible,
    hide,
    remove
  } = useModal(UploadTypeSelectionModal);
  const {
    t
  } = useTranslation(['store']);
  return <Dialog open={visible} onClose={hide} afterClose={remove} drawer data-sentry-element="Dialog" data-sentry-component="UploadTypeSelectionModalInner" data-sentry-source-file="UploadTypeSelectionModal.tsx">
      <DialogOverlay data-sentry-element="DialogOverlay" data-sentry-source-file="UploadTypeSelectionModal.tsx" />
      <DialogPanel className={S.modal_wrapper} data-sentry-element="DialogPanel" data-sentry-source-file="UploadTypeSelectionModal.tsx">
        <DialogHeader onClose={hide} className={S.modal_header} data-sentry-element="DialogHeader" data-sentry-source-file="UploadTypeSelectionModal.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="UploadTypeSelectionModal.tsx">{t('store:store_register_asset')}</DialogTitle>
        </DialogHeader>
        <DialogContent className={S.modal_body} data-sentry-element="DialogContent" data-sentry-source-file="UploadTypeSelectionModal.tsx">
          <UploadTypeSelectionCard type={StoreCategoryString.map} titleKey={'store:store_asset_map'} data-sentry-element="UploadTypeSelectionCard" data-sentry-source-file="UploadTypeSelectionModal.tsx" />
          <UploadTypeSelectionCard type={StoreCategoryString.object} titleKey={'store:store_asset_object_set'} data-sentry-element="UploadTypeSelectionCard" data-sentry-source-file="UploadTypeSelectionModal.tsx" />
          <UploadTypeSelectionCard type={StoreCategoryString.app} titleKey={'store:store_asset_app'} data-sentry-element="UploadTypeSelectionCard" data-sentry-source-file="UploadTypeSelectionModal.tsx" />
          <UploadTypeSelectionCard type={StoreCategoryString.game} titleKey={'store:store_asset_game'} data-sentry-element="UploadTypeSelectionCard" data-sentry-source-file="UploadTypeSelectionModal.tsx" />
        </DialogContent>
      </DialogPanel>
    </Dialog>;
};
export const UploadTypeSelectionModal = NiceModal.create(UploadTypeSelectionModalInner);